import Register from './register/reducer'
import Upload from './upload/reducer'
import Gocar from './gocar/reducer'
import Loading from './loading/reducer'
import Error from './error/reducer'

export default {
    Gocar,
    Register,
    Upload,
    Loading,
    Error
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js